import { gql } from '@apollo/client';

export const LOGIN = gql(/* GraphQL */ `
    mutation Login($input: LoginInput!) {
        login(loginInput: $input) {
            accessToken
            refreshToken
            user {
                firstName
            }
        }
    }
`);

export const IMPERSONATE_USER = gql(/* GraphQL */ `
    mutation ImpersonateUser($userToImpersonateId: String!) {
        impersonateUser(userToImpersonateId: $userToImpersonateId) {
            accessToken
            refreshToken
        }
    }
`);

export const REQUEST_LOGIN_OTP = gql(/* GraphQL */ `
    mutation RequestLoginOTP($input: RequestLoginOTPInput!) {
        requestLoginOtp(requestLoginOtpInput: $input) {
            successful
        }
    }
`);

export const VERIFY_LOGIN_OTP = gql(/* GraphQL */ `
    mutation VerifyLoginOTP($input: VerifyLoginOTPInput!) {
        verifyLoginOtp(verifyLoginOtpInput: $input) {
            accessToken
            refreshToken
            user {
                id
                firstName
            }
        }
    }
`);

export const LOGOUT = gql(/* GraphQL */ `
    mutation Logout {
        logout {
            successful
        }
    }
`);

export const SEND_INVITE = gql(/* GraphQL */ `
    mutation SendInvite($userId: String!) {
        sendInvite(userId: $userId) {
            successful
        }
    }
`);

export const VERIFY_OTP = gql(/* GraphQL */ `
    mutation VerifyOTP($input: VerifyOTPInput!) {
        verifyOTP(verifyOTPInput: $input) {
            successful
        }
    }
`);

export const REFRESH_TOKENS = gql(/* GraphQL */ `
    mutation RefreshTokens {
        refreshTokens {
            accessToken
            refreshToken
        }
    }
`);
